<script>
	import Row from './Row.svelte';
	import Router from "svelte-spa-router";
	import { routes } from "./routes/routesConfig";

</script>

<main>
	<Router {routes} restoreScrollState={true} />
</main>

<style type="text/scss">
	main {
		// max-width: clamp(1600px,1600px,90vw);
		// margin: 0 auto;
	}
</style>